


import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ScrollToTop from './ScrollToTop';
import Constants from './components/Constants';


function App() {

  /* const [language, setLanguage] = useState('en'); */
  /* const [currentPage, setCurrentPage] = useState('Home'); */
  const [setCurrentPage] = useState('Home');

  /* 000000 Idioma del navegador  */
  const browserLang = (window.navigator.language || 'ru').substr(0, 2);
  const [language, setLanguage] = useState(browserLang);
  console.log('language:', language);
  /* 000000 */

  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
  };

  const navigateTo = (page) => {
    setCurrentPage(page);
  };

  const CurrentLanguageComponents = Constants[language];


  return (

    <Router>

      <Helmet>
         {/* Google Analytics */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-M8J14HSL78"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-M8J14HSL78');
          `}
        </script>

         {/* Yandex.Metrica */}
         <script type="text/javascript">
          {`
            (function(m,e,t,r,i,k,a){
              m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
              m[i].l=1*new Date();
              for (var j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) { return; }
              }
              k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
            })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

            ym(97509138, "init", {
                clickmap:true,
                trackLinks:true,
                accurateTrackBounce:true,
                webvisor:true
            });
          `}
        </script>

        <noscript>
        {`<div><img src="https://mc.yandex.ru/watch/97509138" style="position:absolute; left:-9999px;" alt="" /></div>`}
        </noscript>
      </Helmet>


      <div>

        <CurrentLanguageComponents.Menu changeLanguage={changeLanguage} navigateTo={navigateTo} />
        <ScrollToTop />

        <Routes>

          <Route path="/" element={<CurrentLanguageComponents.Home />} />
          <Route path="/about" element={<CurrentLanguageComponents.Home />} />
          <Route path="/contact" element={<CurrentLanguageComponents.Contact />} />
          <Route path="/support" element={<CurrentLanguageComponents.Support />} />

          <Route path="/blog-details" element={<CurrentLanguageComponents.BlogDetails />} />
          <Route path="/category" element={<CurrentLanguageComponents.Category />} />

          <Route path="/events-culture" element={<CurrentLanguageComponents.EventsCulture />} />
          <Route path="/events-dance" element={<CurrentLanguageComponents.EventsDance />} />
          <Route path="/events-spanish" element={<CurrentLanguageComponents.EventSpanish />} />
          <Route path="/gallery" element={<CurrentLanguageComponents.Gallery />} />
          <Route path="/photos" element={<CurrentLanguageComponents.Photos />} />
          <Route path="/projects" element={<CurrentLanguageComponents.Projects />} />
          <Route path="/restaurants" element={<CurrentLanguageComponents.RestaHome />} />
          <Route path="/spanish-courses" element={<CurrentLanguageComponents.SpanishLanguage />} />
          <Route path="/schools-dance" element={<CurrentLanguageComponents.SchoolsDance />} />
          <Route path="/schools-spanish" element={<CurrentLanguageComponents.SchoolsSpanish />} />
          <Route path="/store" element={<CurrentLanguageComponents.Store />} />
          <Route path="/teachers-spanish" element={<CurrentLanguageComponents.TeacherSpanish />} />
          <Route path="/teachers-dance" element={<CurrentLanguageComponents.TeachersDance />} />
          <Route path="/video-events" element={<CurrentLanguageComponents.VideoEvents />} />


          <Route path="/la-bachata-manuel-turizo" element={<CurrentLanguageComponents.TurizoLaBachata />} />
          <Route path="/latino-dance-in-Moscow" element={<CurrentLanguageComponents.LatinoDanceMoscow />} />
          <Route path="/travel-to-spain" element={<CurrentLanguageComponents.TravelToSpain />} />
          <Route path="/new-year-Latam" element={<CurrentLanguageComponents.NewYearLatam />} />
          <Route path="/open-air-in-Moscow" element={<CurrentLanguageComponents.OpenAirMoscow />} />
          <Route path="/latina-fest-Moscow" element={<CurrentLanguageComponents.LatinaFestMoscow />} />

          <Route path="/salsateca" element={<CurrentLanguageComponents.Salsateca />} />

          <Route path="/photo-240509" element={<CurrentLanguageComponents.Photo240509 />} />
          <Route path="/store-alpaca" element={<CurrentLanguageComponents.StoreAlpaca />} />
          <Route path="/store-peru" element={<CurrentLanguageComponents.StorePeru />} />

          
                    
          <Route path="/video-open-14-05-26" element={<CurrentLanguageComponents.VideoOpen260514 />} />
          <Route path="/video-open-13-05-26" element={<CurrentLanguageComponents.VideoOpen260513 />} />
          <Route path="/video-open-12-05-26" element={<CurrentLanguageComponents.VideoOpen260512 />} />
          <Route path="/video-open-10-05-26" element={<CurrentLanguageComponents.VideoOpen260510 />} />
          <Route path="/video-open-09-05-26" element={<CurrentLanguageComponents.VideoOpen260509 />} />
          <Route path="/video-open-06-05-26" element={<CurrentLanguageComponents.VideoOpen260506 />} />
          <Route path="/video-open-03-05-26" element={<CurrentLanguageComponents.VideoOpen260503 />} />
          <Route path="/video-open-26-04-26" element={<CurrentLanguageComponents.VideoOpen260426 />} />
          <Route path="/video-open-19-04-26" element={<CurrentLanguageComponents.VideoOpen260419 />} />
          <Route path="/video-open-12-04-26" element={<CurrentLanguageComponents.VideoOpen260412 />} />
          <Route path="/video-open-05-04-26" element={<CurrentLanguageComponents.VideoOpen260405 />} />
          <Route path="/video-open-29-03-26" element={<CurrentLanguageComponents.VideoOpen260329 />} />
          <Route path="/video-open-22-03-26" element={<CurrentLanguageComponents.VideoOpen260322 />} />
          <Route path="/video-open-15-03-26" element={<CurrentLanguageComponents.VideoOpen260315 />} />
          <Route path="/video-open-08-03-26" element={<CurrentLanguageComponents.VideoOpen260308 />} />
          <Route path="/video-open-01-03-26" element={<CurrentLanguageComponents.VideoOpen260301 />} />
          <Route path="/video-open-22-02-26" element={<CurrentLanguageComponents.VideoOpen260222 />} />
          <Route path="/video-open-15-02-26" element={<CurrentLanguageComponents.VideoOpen260215 />} />
          <Route path="/video-open-01-02-26" element={<CurrentLanguageComponents.VideoOpen260201 />} />
          <Route path="/video-open-25-01-26" element={<CurrentLanguageComponents.VideoOpen260125 />} />
          <Route path="/video-open-18-01-26" element={<CurrentLanguageComponents.VideoOpen260118 />} />
          <Route path="/video-open-11-01-26" element={<CurrentLanguageComponents.VideoOpen260111 />} />
          <Route path="/video-open-04-01-26" element={<CurrentLanguageComponents.VideoOpen260104 />} />
          <Route path="/video-open-28-12-25" element={<CurrentLanguageComponents.VideoOpen251228 />} />
          <Route path="/video-open-21-12-25" element={<CurrentLanguageComponents.VideoOpen251221 />} />
          <Route path="/video-open-14-12-25" element={<CurrentLanguageComponents.VideoOpen251214 />} />
          <Route path="/video-open-30-11-25" element={<CurrentLanguageComponents.VideoOpen251130 />} />
          <Route path="/video-open-23-11-25" element={<CurrentLanguageComponents.VideoOpen251123 />} />
          <Route path="/video-open-16-11-25" element={<CurrentLanguageComponents.VideoOpen251116 />} />
          <Route path="/video-open-09-11-25" element={<CurrentLanguageComponents.VideoOpen251109 />} />
          <Route path="/video-open-02-11-25" element={<CurrentLanguageComponents.VideoOpen251102 />} />
          <Route path="/video-open-26-10-25" element={<CurrentLanguageComponents.VideoOpen251026 />} />
          <Route path="/video-open-19-10-25" element={<CurrentLanguageComponents.VideoOpen251019 />} />
          <Route path="/video-open-12-10-25" element={<CurrentLanguageComponents.VideoOpen251012 />} />
          <Route path="/video-open-05-10-25" element={<CurrentLanguageComponents.VideoOpen251005 />} />
          <Route path="/video-open-28-09-25" element={<CurrentLanguageComponents.VideoOpen250928 />} />
          <Route path="/video-open-22-09-25" element={<CurrentLanguageComponents.VideoOpen250922 />} />
          <Route path="/video-open-21-09-25" element={<CurrentLanguageComponents.VideoOpen250921 />} />
          <Route path="/video-open-20-09-25" element={<CurrentLanguageComponents.VideoOpen250920 />} />
          <Route path="/video-open-17-09-25" element={<CurrentLanguageComponents.VideoOpen250917 />} />
          <Route path="/video-open-15-09-25" element={<CurrentLanguageComponents.VideoOpen250915 />} />
          <Route path="/video-open-14-09-25" element={<CurrentLanguageComponents.VideoOpen250914 />} />
          <Route path="/video-open-13-09-25" element={<CurrentLanguageComponents.VideoOpen250913 />} />
          <Route path="/video-open-11-09-25" element={<CurrentLanguageComponents.VideoOpen250911 />} />
          <Route path="/video-open-10-09-25" element={<CurrentLanguageComponents.VideoOpen250910 />} />
          <Route path="/video-open-08-09-25" element={<CurrentLanguageComponents.VideoOpen250908 />} />
          <Route path="/video-open-07-09-25" element={<CurrentLanguageComponents.VideoOpen250907 />} />
          <Route path="/video-open-06-09-25" element={<CurrentLanguageComponents.VideoOpen250906 />} />
          <Route path="/video-open-04-09-25" element={<CurrentLanguageComponents.VideoOpen250904 />} />
          <Route path="/video-open-03-09-25" element={<CurrentLanguageComponents.VideoOpen250903 />} />
          <Route path="/video-open-01-09-25" element={<CurrentLanguageComponents.VideoOpen250901 />} />
          <Route path="/video-open-31-08-25" element={<CurrentLanguageComponents.VideoOpen250831 />} />
          <Route path="/video-open-30-08-25" element={<CurrentLanguageComponents.VideoOpen250830 />} />
          <Route path="/video-open-28-08-25" element={<CurrentLanguageComponents.VideoOpen250828 />} />
          <Route path="/video-open-27-08-25" element={<CurrentLanguageComponents.VideoOpen250827 />} />
          <Route path="/video-open-25-08-25" element={<CurrentLanguageComponents.VideoOpen250825 />} />
          <Route path="/video-open-24-08-25" element={<CurrentLanguageComponents.VideoOpen250824 />} />
          <Route path="/video-open-23-08-25" element={<CurrentLanguageComponents.VideoOpen250823 />} />
          <Route path="/video-open-21-08-25" element={<CurrentLanguageComponents.VideoOpen250821 />} />
          <Route path="/video-open-17-08-25" element={<CurrentLanguageComponents.VideoOpen250817 />} />
          <Route path="/video-open-16-08-25" element={<CurrentLanguageComponents.VideoOpen250816 />} />
          <Route path="/video-open-14-08-25" element={<CurrentLanguageComponents.VideoOpen250814 />} />
          <Route path="/video-open-13-08-25" element={<CurrentLanguageComponents.VideoOpen250813 />} />
          <Route path="/video-open-11-08-25" element={<CurrentLanguageComponents.VideoOpen250811 />} />
          <Route path="/video-open-10-08-25" element={<CurrentLanguageComponents.VideoOpen250810 />} />
          <Route path="/video-open-09-08-25" element={<CurrentLanguageComponents.VideoOpen250809 />} />
          <Route path="/video-open-07-08-25" element={<CurrentLanguageComponents.VideoOpen250807 />} />
          <Route path="/video-open-06-08-25" element={<CurrentLanguageComponents.VideoOpen250806 />} />
          <Route path="/video-open-05-08-25" element={<CurrentLanguageComponents.VideoOpen250805 />} />
          <Route path="/video-open-03-08-25" element={<CurrentLanguageComponents.VideoOpen250803 />} />
          <Route path="/video-open-02-08-25" element={<CurrentLanguageComponents.VideoOpen250802 />} />
          <Route path="/video-open-01-08-25" element={<CurrentLanguageComponents.VideoOpen250801 />} />
          <Route path="/video-open-31-07-25" element={<CurrentLanguageComponents.VideoOpen250731 />} />
          <Route path="/video-open-30-07-25" element={<CurrentLanguageComponents.VideoOpen250730 />} />
          <Route path="/video-open-29-07-25" element={<CurrentLanguageComponents.VideoOpen250729 />} />
          <Route path="/video-open-28-07-25" element={<CurrentLanguageComponents.VideoOpen250728 />} />
          <Route path="/video-open-27-07-25" element={<CurrentLanguageComponents.VideoOpen250727 />} />
          <Route path="/video-open-26-07-25" element={<CurrentLanguageComponents.VideoOpen250726 />} />
          <Route path="/video-open-25-07-25" element={<CurrentLanguageComponents.VideoOpen250725 />} />
          <Route path="/video-open-23-07-25" element={<CurrentLanguageComponents.VideoOpen250723 />} />
          <Route path="/video-open-22-07-25" element={<CurrentLanguageComponents.VideoOpen250722 />} />
          <Route path="/video-open-21-07-25" element={<CurrentLanguageComponents.VideoOpen250721 />} />
          <Route path="/video-open-20-07-25" element={<CurrentLanguageComponents.VideoOpen250720 />} />
          <Route path="/video-open-18-07-25" element={<CurrentLanguageComponents.VideoOpen250718 />} />
          <Route path="/video-open-17-07-25" element={<CurrentLanguageComponents.VideoOpen250717 />} />
          <Route path="/video-open-16-07-25" element={<CurrentLanguageComponents.VideoOpen250716 />} />
          <Route path="/video-open-14-07-25" element={<CurrentLanguageComponents.VideoOpen250714 />} />
          <Route path="/video-open-13-07-25" element={<CurrentLanguageComponents.VideoOpen250713 />} />
          <Route path="/video-open-12-07-25" element={<CurrentLanguageComponents.VideoOpen250712 />} />
          <Route path="/video-open-11-07-25" element={<CurrentLanguageComponents.VideoOpen250711 />} />
          <Route path="/video-open-10-07-25" element={<CurrentLanguageComponents.VideoOpen250710 />} />
          <Route path="/video-open-09-07-25" element={<CurrentLanguageComponents.VideoOpen250709 />} />
          <Route path="/video-open-07-07-25" element={<CurrentLanguageComponents.VideoOpen250707 />} />
          <Route path="/video-open-06-07-25" element={<CurrentLanguageComponents.VideoOpen250706 />} />
          <Route path="/video-open-05-07-25" element={<CurrentLanguageComponents.VideoOpen250705 />} />
          <Route path="/video-open-04-07-25" element={<CurrentLanguageComponents.VideoOpen250704 />} />
          <Route path="/video-open-03-07-25" element={<CurrentLanguageComponents.VideoOpen250703 />} />
          <Route path="/video-open-02-07-25" element={<CurrentLanguageComponents.VideoOpen250702 />} />
          <Route path="/video-open-28-06-25" element={<CurrentLanguageComponents.VideoOpen250628 />} />
          <Route path="/video-open-25-06-25" element={<CurrentLanguageComponents.VideoOpen250625 />} />
          <Route path="/video-open-23-06-25" element={<CurrentLanguageComponents.VideoOpen250623 />} />
          <Route path="/video-open-16-06-25" element={<CurrentLanguageComponents.VideoOpen250616 />} />
          <Route path="/video-open-12-06-25" element={<CurrentLanguageComponents.VideoOpen250612 />} />
          <Route path="/video-open-11-06-25" element={<CurrentLanguageComponents.VideoOpen250611 />} />
          <Route path="/video-open-07-06-25" element={<CurrentLanguageComponents.VideoOpen250607 />} />
          <Route path="/video-open-06-06-25" element={<CurrentLanguageComponents.VideoOpen250606 />} />
          <Route path="/video-open-05-06-25" element={<CurrentLanguageComponents.VideoOpen250605 />} />
          <Route path="/video-open-04-06-25" element={<CurrentLanguageComponents.VideoOpen250604 />} />
          <Route path="/video-open-01-06-25" element={<CurrentLanguageComponents.VideoOpen250601 />} />
          <Route path="/video-open-31-05-25" element={<CurrentLanguageComponents.VideoOpen250531 />} />
          <Route path="/video-open-30-05-25" element={<CurrentLanguageComponents.VideoOpen250530 />} />
          <Route path="/video-open-29-05-25" element={<CurrentLanguageComponents.VideoOpen250529 />} />
          <Route path="/video-open-28-05-25" element={<CurrentLanguageComponents.VideoOpen250528 />} />
          <Route path="/video-open-25-05-25" element={<CurrentLanguageComponents.VideoOpen250525 />} />
          <Route path="/video-open-24-05-25" element={<CurrentLanguageComponents.VideoOpen250524 />} />
          <Route path="/video-open-23-05-25" element={<CurrentLanguageComponents.VideoOpen250523 />} />
          <Route path="/video-open-22-05-25" element={<CurrentLanguageComponents.VideoOpen250522 />} />
          <Route path="/video-open-19-04-25" element={<CurrentLanguageComponents.VideoOpen250419 />} />
          <Route path="/video-open-18-04-25" element={<CurrentLanguageComponents.VideoOpen250418 />} />

          <Route path="/video-open-18-05-24" element={<CurrentLanguageComponents.VideoOpen240518 />} />
          <Route path="/video-open-19-05-24" element={<CurrentLanguageComponents.VideoOpen240519 />} />
          <Route path="/video-open-25-05-24" element={<CurrentLanguageComponents.VideoOpen240525 />} />
          <Route path="/video-open-28-05-24" element={<CurrentLanguageComponents.VideoOpen240528 />} />
          <Route path="/video-open-30-05-24" element={<CurrentLanguageComponents.VideoOpen240530 />} />
          <Route path="/video-open-31-05-24" element={<CurrentLanguageComponents.VideoOpen240531 />} />
          <Route path="/video-open-02-06-24" element={<CurrentLanguageComponents.VideoOpen240602 />} />
          <Route path="/video-open-07-06-24" element={<CurrentLanguageComponents.VideoOpen240607 />} />
          <Route path="/video-open-08-06-24" element={<CurrentLanguageComponents.VideoOpen240608 />} />
          <Route path="/video-open-09-06-24" element={<CurrentLanguageComponents.VideoOpen240609 />} />
          <Route path="/video-open-14-06-24" element={<CurrentLanguageComponents.VideoOpen240614 />} />
          <Route path="/video-open-15-06-24" element={<CurrentLanguageComponents.VideoOpen240615 />} />
          <Route path="/video-open-16-06-24" element={<CurrentLanguageComponents.VideoOpen240616 />} />
          <Route path="/video-open-19-06-24" element={<CurrentLanguageComponents.VideoOpen240619 />} />
          <Route path="/video-open-21-06-24" element={<CurrentLanguageComponents.VideoOpen240621 />} />
          <Route path="/video-open-22-06-24" element={<CurrentLanguageComponents.VideoOpen240622 />} />
          <Route path="/video-open-23-06-24" element={<CurrentLanguageComponents.VideoOpen240623 />} />
          <Route path="/video-open-25-06-24" element={<CurrentLanguageComponents.VideoOpen240625 />} />
          <Route path="/video-open-26-06-24" element={<CurrentLanguageComponents.VideoOpen240626 />} />
          <Route path="/video-open-28-06-24" element={<CurrentLanguageComponents.VideoOpen240628 />} />
          <Route path="/video-open-29-06-24" element={<CurrentLanguageComponents.VideoOpen240629 />} />
          <Route path="/video-open-30-06-24" element={<CurrentLanguageComponents.VideoOpen240630 />} />
          <Route path="/video-open-01-07-24" element={<CurrentLanguageComponents.VideoOpen240701 />} />
          <Route path="/video-open-02-07-24" element={<CurrentLanguageComponents.VideoOpen240702 />} />
          <Route path="/video-open-03-07-24" element={<CurrentLanguageComponents.VideoOpen240703 />} />
          <Route path="/video-open-06-07-24" element={<CurrentLanguageComponents.VideoOpen240706 />} />
          <Route path="/video-open-07-07-24" element={<CurrentLanguageComponents.VideoOpen240707 />} />
          <Route path="/video-open-09-07-24" element={<CurrentLanguageComponents.VideoOpen240709 />} />
          <Route path="/video-open-10-07-24" element={<CurrentLanguageComponents.VideoOpen240710 />} />
          <Route path="/video-open-12-07-24" element={<CurrentLanguageComponents.VideoOpen240712 />} />
          <Route path="/video-open-13-07-24" element={<CurrentLanguageComponents.VideoOpen240713 />} />
          <Route path="/video-open-14-07-24" element={<CurrentLanguageComponents.VideoOpen240714 />} /> 
          <Route path="/video-open-16-07-24" element={<CurrentLanguageComponents.VideoOpen240716 />} />
          <Route path="/video-open-17-07-24" element={<CurrentLanguageComponents.VideoOpen240717 />} /> 
          <Route path="/video-open-18-07-24" element={<CurrentLanguageComponents.VideoOpen240718 />} />
          <Route path="/video-open-19-07-24" element={<CurrentLanguageComponents.VideoOpen240719 />} />
          <Route path="/video-open-20-07-24" element={<CurrentLanguageComponents.VideoOpen240720 />} />
          <Route path="/video-open-23-07-24" element={<CurrentLanguageComponents.VideoOpen240723 />} />
          <Route path="/video-open-25-07-24" element={<CurrentLanguageComponents.VideoOpen240725 />} />
          <Route path="/video-open-31-07-24" element={<CurrentLanguageComponents.VideoOpen240731 />} />
          <Route path="/video-open-01-08-24" element={<CurrentLanguageComponents.VideoOpen240801 />} />
          <Route path="/video-open-02-08-24" element={<CurrentLanguageComponents.VideoOpen240802 />} />
          <Route path="/video-open-03-08-24" element={<CurrentLanguageComponents.VideoOpen240803 />} />
          <Route path="/video-open-04-08-24" element={<CurrentLanguageComponents.VideoOpen240804 />} />
          <Route path="/video-open-06-08-24" element={<CurrentLanguageComponents.VideoOpen240806 />} />
          <Route path="/video-open-07-08-24" element={<CurrentLanguageComponents.VideoOpen240807 />} />
          <Route path="/video-open-08-08-24" element={<CurrentLanguageComponents.VideoOpen240808 />} />
          <Route path="/video-open-09-08-24" element={<CurrentLanguageComponents.VideoOpen240809 />} />
          <Route path="/video-open-10-08-24" element={<CurrentLanguageComponents.VideoOpen240810 />} />
          <Route path="/video-open-13-08-24" element={<CurrentLanguageComponents.VideoOpen240813 />} />
          <Route path="/video-open-14-08-24" element={<CurrentLanguageComponents.VideoOpen240814 />} />
          <Route path="/video-open-15-08-24" element={<CurrentLanguageComponents.VideoOpen240815 />} />
          <Route path="/video-open-16-08-24" element={<CurrentLanguageComponents.VideoOpen240816 />} />
          <Route path="/video-open-20-08-24" element={<CurrentLanguageComponents.VideoOpen240820 />} />
          <Route path="/video-open-21-08-24" element={<CurrentLanguageComponents.VideoOpen240821 />} />
          <Route path="/video-open-22-08-24" element={<CurrentLanguageComponents.VideoOpen240822 />} />
          <Route path="/video-open-23-08-24" element={<CurrentLanguageComponents.VideoOpen240823 />} />
          <Route path="/video-open-24-08-24" element={<CurrentLanguageComponents.VideoOpen240824 />} />
          <Route path="/video-open-25-08-24" element={<CurrentLanguageComponents.VideoOpen240825 />} />
          <Route path="/video-open-ship" element={<CurrentLanguageComponents.VideoOpenShip />} />
          <Route path="/video-open-27-08-24" element={<CurrentLanguageComponents.VideoOpen240827 />} />
          <Route path="/video-open-28-08-24" element={<CurrentLanguageComponents.VideoOpen240828 />} />
          <Route path="/video-open-30-08-24" element={<CurrentLanguageComponents.VideoOpen240830 />} />
          <Route path="/video-open-31-08-24" element={<CurrentLanguageComponents.VideoOpen240831 />} />
          <Route path="/video-open-01-09-24" element={<CurrentLanguageComponents.VideoOpen240901 />} />
          <Route path="/video-open-03-09-24" element={<CurrentLanguageComponents.VideoOpen240903 />} />
          <Route path="/video-open-04-09-24" element={<CurrentLanguageComponents.VideoOpen240904 />} />
          <Route path="/video-open-05-09-24" element={<CurrentLanguageComponents.VideoOpen240905 />} />
          <Route path="/video-open-06-09-24" element={<CurrentLanguageComponents.VideoOpen240906 />} />
          <Route path="/video-open-07-09-24" element={<CurrentLanguageComponents.VideoOpen240907 />} />
          <Route path="/video-open-08-09-24" element={<CurrentLanguageComponents.VideoOpen240908 />} />
          <Route path="/video-open-10-09-24" element={<CurrentLanguageComponents.VideoOpen240910 />} />
          <Route path="/video-open-11-09-24" element={<CurrentLanguageComponents.VideoOpen240911 />} />
          <Route path="/video-open-12-09-24" element={<CurrentLanguageComponents.VideoOpen240912 />} />
          <Route path="/video-open-13-09-24" element={<CurrentLanguageComponents.VideoOpen240913 />} />
          <Route path="/video-open-14-09-24" element={<CurrentLanguageComponents.VideoOpen240914 />} />
          <Route path="/video-open-15-09-24" element={<CurrentLanguageComponents.VideoOpen240915 />} />
          <Route path="/video-open-16-09-24" element={<CurrentLanguageComponents.VideoOpen240916 />} />
          <Route path="/video-open-17-09-24" element={<CurrentLanguageComponents.VideoOpen240917 />} />
          <Route path="/video-open-18-09-24" element={<CurrentLanguageComponents.VideoOpen240918 />} />
          <Route path="/video-open-19-09-24" element={<CurrentLanguageComponents.VideoOpen240919 />} />          
          <Route path="/video-open-21-09-24" element={<CurrentLanguageComponents.VideoOpen240921 />} />
          <Route path="/video-open-25-09-24" element={<CurrentLanguageComponents.VideoOpen240925 />} />
          <Route path="/video-open-26-09-24" element={<CurrentLanguageComponents.VideoOpen240926 />} />
          <Route path="/brillo-latino-09-10-24" element={<CurrentLanguageComponents.VideoBrillo241009 />} />
          <Route path="/brillo-latino-17-10-24" element={<CurrentLanguageComponents.VideoBrillo241017 />} />
          <Route path="/brillo-latino-31-10-24" element={<CurrentLanguageComponents.VideoBrillo241031 />} />
          <Route path="/brillo-latino-14-11-24" element={<CurrentLanguageComponents.VideoBrillo241114 />} />
          <Route path="/brillo-latino-21-11-24" element={<CurrentLanguageComponents.VideoBrillo241121 />} />
          <Route path="/brillo-latino-28-11-24" element={<CurrentLanguageComponents.VideoBrillo241128 />} />
          <Route path="/brillo-latino-05-12-24" element={<CurrentLanguageComponents.VideoBrillo241205 />} />
          <Route path="/brillo-latino-26-12-24" element={<CurrentLanguageComponents.VideoBrillo241226 />} />
          <Route path="/wilkin-dance-25-01-25" element={<CurrentLanguageComponents.VideoWDance250125 />} /> 
          <Route path="/el-tardeo-24-05-25" element={<CurrentLanguageComponents.VideoTardeo250524 />} />         



        </Routes>
       
      </div>


    </Router>


  );
}

export default App;



